@layer ui-kit;
@layer ui-kit {
  ._9xrfk60 {
    color: var(--_1qu8za23n);
  }
  ._9xrfk60:hover {
    text-decoration: underline;
  }
}